//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


import { mapGetters, mapActions } from "vuex";
import { copyToClipboard } from "@/assets/js/appFunc";
import AQInput from "@/components/Generics/AQInput/AQInput.vue";
import AQButton from "@/components/Generics/AQButton/AQButton.vue";
import setExternalStartMapRequest from "@/components/Diagram/setExternalStartMapRequest.vue";
import FabricSearch from "@/components/q-fabric-search.vue";
import AQTooltip from "@/components/Generics/AQTooltip/AQTooltip.vue";
import AQModal from "@/components/Generics/AQModal/AQModal.vue";
import AQCard from "@/components/Generics/AQCard/AQCard.vue";
import AQCheckbox from "@/components/Generics/AQCheckbox/AQCheckbox.vue";

export default {
    name: "SetExternalStart",
    components: {
        AQInput,
        setExternalStartMapRequest,
        FabricSearch,
        AQTooltip,
        AQButton,
        AQModal,
        AQCheckbox,
        AQCard
    },
    props: {
        uuid: {
            type: String
        },
        value: {
            type: Object
        },
        readonly: {
            type: Boolean
        }
    },
    data() {
        return {
            externalClientsModalOpened: false,
            showExternalClientsSave: false,
            localClients: null,
            availableClients: false,
            dataModelModalOpened: false,
            showDataModelSave: false,
            localDataModelFields: {},
            search: "",
            mapRequestFinalData: false,
            nrMappedFields: 0,
            nrRules: "no ",
            done: { label: this.$t("generic.done") }
        };
    },
    computed: {
        ...mapGetters("main", ["getCurrentApplicationId"]),
        ...mapGetters("diagrams", ["externalStartUrl", "selectedPluginConfigData", "modelForProcessDefinition"]),
        ...mapGetters("apis", ["allExposedApis"]),
        ...mapGetters("version", ["latestVersionId"]),

        localComputedClients: {
            get() {
                return this.localClients || (this.value ? this.value.startClients : []);
            },
            set(v) {
                this.localClients = v || [];
            }
        },
        computedSavedClients() {
            const clients = [];
            const extraClients = [];

            if (this.value && this.value.startClients && this.value.startClients.length) {
                this.value.startClients.forEach(el => {
                    const client = this.allExposedApis.filter(item => item.id === el);

                    if (client && client.length) {
                        if (clients.length < 2) {
                            clients.push(client[0]);
                        } else {
                            extraClients.push(client[0]);
                        }
                    }
                });

                if (extraClients.length) {
                    clients.push({
                        name: `+ ${extraClients.length}`,
                        id: extraClients.length
                    });
                }
            }

            return clients;
        },
        computedModel() {
            return this.modelForProcessDefinition({ hideCatalogFields: true });
        },
        filterAllExposedApis() {
            let apis = [];
            if (this.search) {
                const lowerCaseValue = this.search.toLowerCase();
                apis = this.allExposedApis.filter(item => (item.name ? item.name.toLowerCase().includes(lowerCaseValue) : false));
            } else {
                apis = this.allExposedApis;
            }
            return apis;
        }
    },
    watch: {
        localClients(v) {
            if (v) {
                this.showExternalClientsSave = true;
            }
        },
        localDataModelFields: {
            handler(v) {
                if (v) {
                    this.showDataModelSave = true;
                }
            },
            deep: true
        },
        allExposedApis: {
            handler(newValue) {
                this.availableClients = !!(newValue && newValue.length > 0);
            },
            immediate: true
        }
    },
    created() {
        this.availableClients = !!(this.allExposedApis && this.allExposedApis.length > 0);
        this.mapRequestFinalData = this.selectedPluginConfigData && this.selectedPluginConfigData.externalStart
                                && (this.selectedPluginConfigData.externalStart.dataModelFields.length
                                || (this.selectedPluginConfigData.rules && this.selectedPluginConfigData.rules.length));
        if (this.mapRequestFinalData) {
            this.nrMappedFields = this.selectedPluginConfigData.externalStart.dataModelFields.length;
            this.nrRules = this.selectedPluginConfigData.rules && this.selectedPluginConfigData.rules.length
                ? this.selectedPluginConfigData.rules.length : "no ";
        }
    },
    activated() {
        this.getExternalData();
    },
    mounted() {
        this.getExternalData();
    },
    methods: {
        copyToClipboard,
        ...mapActions("diagrams", ["getUrl"]),
        ...mapActions("apis", ["getAllExposedApis"]),
        externalClientsDlgAction($event) {
            if ($event === "primary") {
                this.$emit("input", {
                    startClients: this.localClients,
                    dataModelFields: this.value ? (this.value.dataModelFields || []) : [],
                    startParams: this.value ? (this.value.startParams || {}) : {}
                });
            } else if ($event === "close") {
                this.localClients = this.value ? this.value.startClients : null;
            }
            this.externalClientsModalOpened = false;
            this.showExternalClientsSave = false;
        },
        goToApi() {
            this.$router.push({ name: "expose", query: { fromExposed: true } });
            this.externalClientsModalOpened = false;
        },
        dataModelDlgAction($event) {
            if ($event.detailed === "action_save") {
                this.$emit("input", {
                    startClients: this.value ? (this.value.startClients || []) : [],
                    dataModelFields: this.localDataModelFields.model,
                    startParams: this.generateStartParams(this.localDataModelFields.model)
                });
            }
            this.dataModelModalOpened = false;
            this.showDataModelSave = false;
            this.localDataModelFields = null;
        },
        openMapRequestDialog() {
            this.dataModelModalOpened = true;
        },
        modalClosed() {
            this.dataModelModalOpened = false;
        },
        getExternalData() {
            this.getAllExposedApisData();
            this.getUrl(this.selectedPluginConfigData.uuid);
        },
        generateStartParams(fieldsSelected) {
            const startParams = {};
            this.computedModel.forEach(el => {
                if (el.fields) {
                    el.fields.forEach(field => {
                        const name = `${el.name}.${field.name}`;
                        if (fieldsSelected.indexOf(name) !== -1) {
                            if (field.isList) {
                                const namePath = `${name}._path_`;
                                startParams[namePath] = `m_${name}`;
                            } else {
                                startParams[name] = `m_${name}`;
                            }
                        }
                        if (field.fields && field.fields.length > 0) {
                            return this.generateStartParamsList(startParams, field.fields, name, fieldsSelected);
                        }
                        return false;
                    });
                }
            });
            return startParams;
        },
        getDataFromMapReqModal(event) {
            this.nrMappedFields = event.dataModelFields.length;
            if (event.rules.length === 0) {
                this.nrRules = "no";
            } else {
                this.nrRules = event.rules.length;
            }
            if (event.dataModelFields.length || event.rules.length) {
                this.mapRequestFinalData = true;
            }
            this.$emit("input", {
                startClients: this.value && this.value.startClients ? this.value.startClients : [],
                dataModelFields: event.dataModelFields.length ? event.dataModelFields : [],
                startParams: event.startParams || {}
            });
            this.$store.commit("diagrams/setConfigData", {
                uuid: this.uuid,
                value: event.rules,
                property: "rules"
            });
        },

        generateStartParamsList(startParams, fields, name, fieldsSelected) {
            fields.forEach(field => {
                const nameList = `${name}.${field.name}`;
                if (fieldsSelected.indexOf(nameList) !== -1) {
                    if (field.isList) {
                        const namePath = `${nameList}._path_`;
                        startParams[namePath] = `m_${nameList}`;
                    } else {
                        startParams[nameList] = `m_${nameList}`;
                    }
                }
                if (field.fields && field.fields.length > 0) {
                    this.generateStartParamsList(startParams, field.fields, nameList, fieldsSelected);
                }
            });
        },
        getAllExposedApisData() {
            if (!this.latestVersionId) {
                this.$store.dispatch("version/getLatestVersionId").then(
                    data => {
                        if (data) {
                            this.getAllExposedApis();
                        }
                    }
                );
            } else {
            // refresh data on open
                this.getAllExposedApis();
            }
        },
        openExternalClientsModal() {
            this.externalClientsModalOpened = true;
            this.getAllExposedApisData();
        }
    }
};
